import { create } from 'zustand'

/**
 * Cross-component bridge to the single global softphone (owned by
 * SoftphoneWidget). Anywhere in the app can request an outbound call —
 * e.g. the "Call" button on a work order's contact — without spawning a
 * second Twilio Device. The widget watches `pendingDial` and places the
 * call when its device is ready.
 */
interface SoftphoneStoreState {
  /** E.164 number a caller wants dialed, or null. */
  pendingDial: string | null
  requestCall: (e164: string) => void
  clearPendingDial: () => void
}

export const useSoftphoneStore = create<SoftphoneStoreState>((set) => ({
  pendingDial: null,
  requestCall: (e164) => set({ pendingDial: e164 }),
  clearPendingDial: () => set({ pendingDial: null }),
}))
